import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import Redis from "../../homepage/header-banner/Redis";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../container/Sidebar/Sidebar";
import "../../container/Sidebar/sidebar.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard";
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute";
import CardBox from "../../container/Box/Components/CardBox";
// import { MuiGrid } from '@mui/material';
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";
import DividerComponent from "../../container/Divider/divider";
import styled from "styled-components";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloudVN from "../../container/Banner/banner-privateCloud-vn";
import Cloudconsult2VN from "../../homepage/consult/cloudconsult-2-vn";
import SidebarVN from "../../container/Sidebar/Sidebar-vn";
import HeaderVn from "../../detailpageVN/Page/component/headervn";
import FooterVn from "../../detailpageVN/Page/component/footervn";

const Sysfont = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;

function ClustercloudredisVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Private Redis Cluster - Private Kubernetes - Private Cloud";
    }, []);
    return (
        <Sysfont className="App">
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for Redis")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Động cơ cơ sở dữ liệu NoSQL hỗ trợ sharding, được triển khai trên cluster Kubernetes.</p>",
                                    `<p class='typo-14'>Dữ liệu được lưu trữ dưới dạng snapshot, đảm bảo tính bền vững và an toàn.</p>
                                <p class='typo-14'>Hỗ trợ sharding phía client nhằm nâng cao hiệu suất ghi, đồng thời nhân bản các node để tối ưu hiệu suất đọc.</p>
                                <p class='typo-14'>Phù hợp cho việc xử lý dữ liệu dạng danh sách, mảng, với khả năng đọc vượt trội, là một engine NoSQL mạnh mẽ và hiệu quả.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Vận hành Persistent Volume với hiệu suất cao, tối ưu hoá hiệu năng I/O.</p>",
                                    `<p class='typo-14'>Hệ thống sử dụng volume SSD PV, với 3 container replica (POD) tạo thành một đơn vị dịch vụ.</p>
                                <p class='typo-14'>Ngay cả khi phần cứng của một worker node trong Kubernetes gặp sự cố, dịch vụ vẫn được duy trì ổn định trên các container (POD) thuộc các worker node khác.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Hệ thống tự động di chuyển container (POD) khi xảy ra sự cố phần cứng, đảm bảo duy trì hoạt động liên tục và không gián đoạn.</p>",
                                    `<p class='typo-14'>Các container (POD) của Kubernetes Redis bao gồm 3 node replica cho mỗi dịch vụ đơn vị.</p> 
                                <p class='typo-14'>Các replica được phân bổ trên nhiều worker node trong Kubernetes, giúp tăng khả năng chịu lỗi và tính sẵn sàng của hệ thống.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Hệ thống hỗ trợ tự động mở rộng quy mô (autoscaling), giúp tăng số lượng container và phân phối tải dịch vụ một cách linh hoạt.</p>",
                                    `<p class='typo-14'>Số lượng container (POD) được điều chỉnh định kỳ dựa trên các chỉ số như CPU, bộ nhớ hoặc các metric tùy chỉnh.</p>
                                <p class='typo-14'>Không cần dự phòng sẵn tài nguyên phần cứng để mở rộng dịch vụ.</p>
                                <p class='typo-14'>Đây là giải pháp cluster hiệu quả, giúp phân phối tải đều và tối ưu chi phí vận hành.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>
                                {Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-cloud-redis/redis_cluster.svg")}
                            </MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        {/* <Redis /> */}

                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
}

const MuiGrid = styled.div`
    padding: 0px;
`;

export default ClustercloudredisVN;
